import React, {ReactNode} from 'react'
import AuthWrapper from './AuthWrapper'

interface RequiresAuthenticationProps {
  children?: ReactNode
  register?: boolean
}

const RequiresAuthentication = ({
  children,
  register = false
}: RequiresAuthenticationProps) => {
  return <AuthWrapper register={register}>{children}</AuthWrapper>
}

export default RequiresAuthentication
